





























import { Component, Prop, Vue } from 'vue-property-decorator'
import SuiPopup from '@/components/Popup/index.vue'
import SuiButton from '@/components/Button/index.vue'
import SuiIcon from '@/components/Icon/index.vue'
import wrapClass from '@/directives/wrap-class'
import touchClass from '@/directives/touch-class'

/**
 * @component
 * @description 弹窗
 */
@Component({
  name: 'SuiModal',
  components: {
    SuiButton, SuiPopup, SuiIcon
  },
  directives: { wrapClass, touchClass }
})
export default class Comp extends SuiPopup {
  static install(vue: any) {
    vue.component((this as any).options.name, Comp)
  }

  /**
  * @prop title
  * @type string
  * @description 标题
  * @default 温馨提示
  */
  @Prop({
    type: String,
    default: '温馨提示'
  })
  title!: string

  /**
  * @prop content
  * @type string
  * @description 内容
  */
  @Prop({
    type: String
  })
  content!: string

  /**
  * @Prop lockScroll
  * @type boolean
  * @description 是否锁定滑动
  * @default true
  */
  @Prop({
    type: Boolean,
    default: true
  })
  lockScroll!: boolean

  /**
  * @prop btn
  * @type string
  * @description 单个按钮时按钮文案
  */
  @Prop({
    type: String,
  })
  btn!: string

  /**
  * @prop btnPrimary
  * @type string
  * @description 双按钮时左边按钮文案
  */
  @Prop({
    type: String,
  })
  btnPrimary!: string

  /**
  * @prop btnEmphasize
  * @type string
  * @description 双按钮时右边按钮文案
  */
  @Prop({
    type: String,
  })
  btnEmphasize!: string

  /**
  * @prop textAlign
  * @type string
  * @description 内容居中方式
  * @options ['left', 'center', 'right']
  * @default center
  */
  @Prop({
    type: String,
    default: 'center',
    validator(val) {
      return ['left', 'center', 'right'].indexOf(val) !== -1
    }
  })
  textAlign!: string

  /**
  * @prop btnType
  * @type string
  * @description 按钮类型
  * @options ['normal', 'emphasize']
  * @default normal
  */
  @Prop({
    type: String,
    default: 'normal',
    validator(val) {
      return ['normal', 'emphasize'].indexOf(val) !== -1
    }
  })
  btnType!: string

  /**
  * @prop showCloseIcon
  * @type boolean
  * @description 是否展示关闭图标
  * @default true
  */
  @Prop({
    type: Boolean,
    default: true,
  })
  showCloseIcon!: boolean

  get textAlignClass() {
    return 'sui-modal-main--' + this.textAlign
  }

  /**
  * @emit close
  * @description 点击右上角的关闭 icon 时触发
  */
  onClose() {
    this.closePopup()
    this.$emit('close')
  }

  /**
  * @emit confirm
  * @description 点击确认按钮时触发
  */
  onConfirm() {
    this.closePopup()
    this.$emit('confirm')
  }

  /**
  * @emit cancel
  * @description 点击取消按钮时触发
  */
  onCancel() {
    this.closePopup()
    this.$emit('cancel')
  }
}

/**
* @slot default
* @description 内容
*/
